import { useEffect, useMemo, useState } from 'react'
import InvoiceReportTable from '../components/InvoiceTables/InvoiceReportTable'
import { useFilterOnConsolidateAgreement } from '../../hooks/useFilterOnConsolidateAgreement'
import { useQuery } from 'react-query'
import { fetchInvoiceReport } from '../../../../api/api'
import { useChosenCompany } from '../../../../context/UserProvider'
import { Select } from '../../../cars/components/V3/_shared/Select'
import { ConsolidateInvoiceSelect } from '../../../cars/components/V3/_shared/ConsolidateInvoiceSelect'
import type { Invoice } from '../../../../types'

const InvoiceReport = () => {
  const company = useChosenCompany()
  const companyId = company?.id

  const [year, yearSet] = useState('')

  const { data: response, status } = useQuery(['invoiceReport', companyId], () => fetchInvoiceReport(companyId), {
    enabled: !!companyId,
  })

  const data = (Array.isArray(response) ? response : response && 'data' in response ? response.data : []) as Invoice[]

  const reportYears = useMemo(() => {
    return Array.from(new Set(data.map((el) => new Date(el.postingDate).getFullYear())))
  }, [data])

  useEffect(() => {
    if (reportYears.length > 0 && year === '') {
      const newestYear = Math.max(...reportYears.map((y) => Number(y))).toString()
      yearSet(newestYear)
    }
  }, [reportYears, year])

  const items = [
    { value: 'all', label: 'Alle' },
    ...reportYears.map((year) => ({ value: String(year), label: String(year) })),
  ]

  const agreementFilter = useFilterOnConsolidateAgreement()
  const filteredData = data
    .filter((el) => year === 'all' || new Date(el.postingDate).getFullYear().toString() === year)
    .filter(agreementFilter('consolidateInvoiceCode'))

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between items-center">
          <span className="text-xl font-medium text-primaryText">Fakturarapport</span>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto">
          <div className="flex-1 md:flex-none">
            <Select className="h-11 w-full" placeholder={'Periode'} options={items} value={year} onChange={yearSet} />
          </div>
          <div className="flex-1 md:flex-none">
            <ConsolidateInvoiceSelect className="h-11 w-full" />
          </div>
        </div>
      </div>

      <InvoiceReportTable isLoading={status === 'loading'} data={filteredData} />
    </div>
  )
}

export default InvoiceReport
